import Input from '../../../../components/forms/input';
import './styles.scss';

const INPUT_SIZE = 2;
import React, { Fragment, useEffect, useRef } from 'react';

interface IDynamicObject {
    [key: string]: string | number;
}

interface IDynamicObjectBoolean {
    [key: string]: boolean;
}

interface IMfaCodesInput {
    handleBlur: Function;
    handleChange: Function;
    touched: IDynamicObjectBoolean;
    values: IDynamicObject;
    setFieldValue: Function;
    setFieldTouched: Function;
}

const mfaCodesInputs = ({
    handleChange,
    values,
    handleBlur,
    touched,
    setFieldValue,
    setFieldTouched,
}: IMfaCodesInput) => {
    const inputs: any = {};
    if (values) {
        Object.keys(values).forEach((value: string) => {
            inputs[value] = useRef(null);
        });
    }

    useEffect(() => {
        const startPosition = Object.keys(inputs)[0];
        inputs[startPosition].current.focus();
    }, []);

    function handlerChangeNumber(event: any) {
        const aux = event.target.value.replace(/\D/g, '');
        const pos: number = Object.keys(inputs).indexOf(event.target.name);
        const length: number = Object.keys(inputs).length;
        if (aux) {
            handleChange(event);
            nextFocus(pos, length);
        } else {
            event.target.value = '';
            handleChange(event);
            previousFocus(pos);
        }
    }
    function nextFocus(pos: number, length: number) {
        if (pos < --length) {
            const ele = Object.keys(inputs)[++pos];
            inputs[ele].current.focus();
        }
    }
    function previousFocus(pos: number) {
        // eslint-disable-next-line no-magic-numbers
        if (pos > 0) {
            const ele = Object.keys(inputs)[--pos];
            inputs[ele].current.focus();
        }
    }
    const onPaste = (event: any) => {
        event.preventDefault();
        const pasted = event.clipboardData.getData('text/plain');
        const splitted = pasted.split('');
        let iterator = 0;
        for (const key of Object.keys(inputs)) {
            setFieldValue(key, splitted[iterator]);
            setTimeout(() => setFieldTouched(key, true));
            nextFocus(
                Object.keys(inputs).indexOf(key),
                Object.keys(inputs).length,
            );
            iterator++;
        }
    };
    const onKeyPress = (event: any) => {
        const key = event.keyCode || event.charCode;
        if (key == '8' || key == '46') {
            event.preventDefault();
            const { name, value } = event.target;
            if (value !== '') {
                previousFocus(Object.keys(inputs).indexOf(name));
                setFieldValue(name, '');
                setTimeout(() => setFieldTouched(name, true));
            } else previousFocus(Object.keys(inputs).indexOf(name));
        }
    };
    return (
        <Fragment>
            <div className={'mfa-input-groups'}>
                {Object.keys(values).map((key, i) => {
                    return (
                        <Input
                            key={i}
                            type={'text'}
                            name={key.toString()}
                            value={values[key]}
                            handlerChange={handlerChangeNumber}
                            handlerBlur={handleBlur}
                            size={INPUT_SIZE}
                            maxlength={1}
                            asTouched={touched[key]}
                            reference={inputs[key]}
                            onPaste={onPaste}
                            handleKeyPress={onKeyPress}
                        />
                    );
                })}
            </div>
        </Fragment>
    );
};

export default React.memo(mfaCodesInputs);
